import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { FeatureFlagService } from './feature-flag.service';
import { FeatureFlagConfigData } from './feature-flag-config.interface';
import { ConfigService } from '../config/config.service';
import { BackendUrlConfig } from '../config/backend-url-config';
import { ResolveFn } from '@angular/router';

export const featureFlagsResolver: ResolveFn<
  FeatureFlagConfigData
> = (): Observable<FeatureFlagConfigData> => {
  const http = inject(HttpClient);
  const featureFlagService = inject(FeatureFlagService);
  const configService = inject(ConfigService<BackendUrlConfig>);

  return http
    .get<FeatureFlagConfigData>(configService.config.psServerUrl + '/api/v1/feature-flags')
    .pipe(tap((data) => featureFlagService.configData.set(data)));
};
